import { SorterResult } from 'antd/lib/table/interface';
import { ISurveyItem } from '../services/surveys';

export const SurveySortOrder: {
  [key: string]: string;
} = {
  ascend: 'asc',
  descend: 'desc',
};

export const useSort = () => {
  const divideAppliedSort = (appliedSort: string | null) => {
    if (appliedSort) {
      const sortArray = appliedSort.split(':');
      return { field: sortArray[0], order: sortArray[1] };
    } else {
      return null;
    }
  };

  const setSortQuery = (sorter: SorterResult<ISurveyItem>) => {
    return sorter.order ? `${sorter.field}:${SurveySortOrder[sorter.order]}` : null;
  };

  const getFieldOrder = (field: string, dividedSort: { field: string; order: string }) => {
    const order = field === dividedSort.field ? dividedSort.order : null;
    return Object.keys(SurveySortOrder).filter(key => SurveySortOrder[key] === order)[0];
  };

  const sortArray = (array: Record<string, number>[], asc: boolean, sortKey: string = 'score') => {
    if(asc){
      return [...array]?.sort((a, b) => a[sortKey] - b[sortKey]);
    }
    return [...array]?.sort((a, b) => b[sortKey] - a[sortKey]);
  };

  return { divideAppliedSort, setSortQuery, getFieldOrder, sortArray };
};
